import React, { Component, Fragment } from "react";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import { connect } from "react-redux";
import RcAutocomplete from "react-autocomplete";
import { Form, Modal, Button } from "shared/components";
import IconRepair from "../../../assets/svg/icone-reparo-modal.svg";
import Loader from "../../../components/Loading";
import { getProducts, getCustomer } from "../../../services/state/actions";
import { selectProduct } from "../../../services/state/repair/action";
import styles from "../styles.css";
import ModalError from "../../ModalError";
import _get from "lodash/get";
import _includes from "lodash/includes";
import { matchStateToTerm, sortStates } from "./util.js";

const productsLimit = process.env.PRODUCTS_LIMIT;
const productsLimitCorp = process.env.PRODUCTS_LIMIT_CORP;

const ERROR_MESSAGES = {
  "LAN to LAN Network": {
    msg:
      "Não é possível abrir um incidente para um contrato de Lan to Lan Network.",
    msg2: "Selecione o circuito correspondente ao Lan to Lan Node.",
  },
  "Clear Channel Network": {
    msg:
      "Não é possível abrir um incidente para um contrato de Clear Channel Network.",
    msg2:
      "Selecione o circuito que está vinculado à uma das pontas do seu Clear Channel.",
  },
  "Ponto de Acesso": {
    msg:
      "Não é possível abrir um incidente para um contrato de Ponto de Acesso.",
  },
};

const CANT_OPEN_INCIDENCT_PRODUCTS = [
  "LAN to LAN Network",
  "Clear Channel Network",
  "Ponto de Acesso",
];

class ModalProducts extends Component {
  state = {
    product: {},
    products: this.props.products || [],
    busy: false,
    typeError: "",
    value: "",
  };

  componentDidMount() {
    this.getProducts();
  }

  componentWillReceiveProps = (nextProps) => {
    this.props.customer && !nextProps.customer && this.props.getCustomer();

    if (nextProps.products !== this.props.products) {
      this.onPopulateResults(nextProps.products);
    }
  };

  getProducts() {
    const { customer } = this.props;
    let productsParams = { page: 0, pageSize: productsLimit };
    this.setState({ busy: true });

    if (customer.customerSegment === "CORPORATE") {
      productsParams = { page: 0, pageSize: productsLimitCorp };
    }

    this.props
      .getProducts(productsParams)
      .then(() => this.setState({ busy: false }));
  }

  onPopulateResults = (products) => {
    this.setState({
      products,
    });
  };

  onSelectHandler = (product) => {
    if (!product) return "";

    if (_includes(CANT_OPEN_INCIDENCT_PRODUCTS, product.productName)) {
      this.setState({
        showErrorModal: true,
        typeError: product.productName,
        product: {},
      });

      return "";
    }

    const currentProduct = this.state.product;
    if (currentProduct.productId !== product.productId) {
      this.setState({ product });
    }

    if (product && product.lineOfBusiness === "VOZ") return product.serviceId;

    return `${_get(product, "productName")} ${_get(product, "circuit")}`;
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.selectProduct(this.state.product);
    this.props.onNextStep();
  };

  handleCloseModal = () => {
    this.setState({
      showErrorModal: false,
    });
  };

  render() {
    const { t, products, isCurrentStep, onPreviousStep, onReset } = this.props;
    const { value } = this.state;

    return (
      <Fragment>
        <Modal
          isOpen={isCurrentStep && products}
          onClose={onReset}
          title={t("MSG_0194")}
          icon={IconRepair}
          ariaHideApp={false}
          noOverflow={true}
        >
          <Form onSubmit={this.onSubmit}>
            <fieldset className={styles.fieldset}>
              <div className={styles.formProduct}>
                <label htmlFor="switcher-products">{t("MSG_0234")}</label>
                <div>
                  <RcAutocomplete
                    value={value}
                    inputProps={{ id: "rcautocomplete" }}
                    wrapperStyle={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                    items={this.state.products}
                    getItemValue={(item) => {
                      return `${item.productName} ${
                        item.lineOfBusiness === "VOZ"
                          ? item.serviceId
                          : item.circuit
                      }`;
                    }}
                    shouldItemRender={matchStateToTerm}
                    sortItems={sortStates}
                    onChange={(event, value) => {
                      this.setState({ value });
                    }}
                    onSelect={(value, item) => {
                      this.setState({ value });
                      return this.onSelectHandler(item);
                    }}
                    renderInput={(props) => (
                      <div className="autocomplete__wrapper">
                        <input
                          className="autocomplete__input autocomplete__input--show-all-values"
                          {...props}
                        />
                        <img
                          className="autocomplete__dropdown-arrow-down"
                          src="/static/media/seta.f5226d91.svg"
                          alt=""
                        />
                      </div>
                    )}
                    renderMenu={(items, value, style) => (
                      <div className="autocomplete__menu autocomplete__menu--overlay">
                        {items.length === 0 ? (
                          <div className="autocomplete__option rc-autocomplete__item">
                            <span>Nenhum resultado encontrado!</span>
                          </div>
                        ) : (
                          items
                        )}
                      </div>
                    )}
                    renderItem={(item, isHighlighted) => (
                      <div
                        className={`autocomplete__option rc-autocomplete__item ${
                          isHighlighted
                            ? "rc-autocomplete__item-highlighted"
                            : ""
                        }`}
                        key={item.productId}
                      >
                        <span>{item.productName}</span>
                        <span>
                          {item.lineOfBusiness === "VOZ"
                            ? item.serviceId
                            : item.circuit}
                        </span>
                      </div>
                    )}
                  />
                </div>
              </div>
            </fieldset>
            <div className={styles.actions}>
              <Button onClick={onPreviousStep} relevance="low">
                {t("MSG_0056")}
              </Button>
              <Button
                type="submit"
                relevance="normal"
                callToAction
                disabled={!this.state.product.productId}
              >
                {t("MSG_0126")}
              </Button>
            </div>
          </Form>
        </Modal>

        <ModalError
          isOpen={this.state.showErrorModal}
          onClose={this.handleCloseModal}
          msg={_get(ERROR_MESSAGES, [this.state.typeError, "msg"])}
          msg2={_get(ERROR_MESSAGES, [this.state.typeError, "msg2"])}
        />

        <Loader isOpen={this.state.busy} />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ products, customer }) => ({
  products: products.repair.data,
  detail: products.detail.data,
  customer: customer.data,
});

const enhance = compose(
  translate(),
  connect(mapStateToProps, {
    getProducts,
    selectProduct,
    getCustomer,
  })
);

export default enhance(ModalProducts);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalProducts.js